import Quiz from './components/Quiz/Quiz';
import { useGetParams } from './hooks/useGetParams';
import { AnimatePresence, motion } from 'framer-motion';
import { useVote } from './hooks/useVote';
import { useMemo } from 'react';
import defaultBgImage from './assets/images/bg.png';
import defaultBgVideo from './assets/videos/bg.mp4';
import Winner from './components/Winner/Winner';
import classNames from 'classnames';
import { BigAdvt } from './components/BigAdvt/BigAdvt';
import AdvtTop from './components/AdvtTop/AdvtTop';

import logoMelbet from './assets/images/logo_melbet.png';
import logoFakel from './assets/images/logo_fakel.png';

function App() {
  const { voteState, currentState, isVisible } = useVote();

  const {
    bgPoster,
    bgVideo,
    phoneNumber,
    socials,
    title1,
    title2FontSize,
    title1FontSize,
    qrCode1,
    qrCode2,
    questionFontSize,
    answerFontSize,
    varNumFontSize,
    winnerFontSize,
  } = useGetParams();

  const advt_info = useMemo(
    () => ({
      qrCode1: qrCode1,
      qrCode2: qrCode2,
      label: title1,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title1, qrCode1, qrCode2]
  );

  return (
    <div
      className={classNames('app-wrapper', {
        large: ['S4', 'S5', 'S6'].includes(currentState),
      })}>
      {bgVideo && bgVideo !== '0' && (
        <video
          autoPlay
          muted
          loop
          className="video-bg"
          poster={
            bgVideo === '1' ? defaultBgImage : bgPoster ?? defaultBgImage
          }>
          <source
            src={bgVideo === '1' ? defaultBgVideo : bgVideo}
            type="video/mp4"
          />
        </video>
      )}

      <AnimatePresence mode="wait">
        {['S2', 'S3'].includes(currentState) && (
          <motion.div
            key="bigAdvt"
            style={{ width: '100%', height: '100%' }}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.5 }}>
            <img src={logoMelbet} alt="logoMelbet" className="logoMelbet" />
            <img src={logoFakel} alt="logoFakel" className="logoFakel" />
            <BigAdvt
              title1FontSize={title1FontSize}
              title2FontSize={title2FontSize}
              currentState={currentState}
              advt_info={advt_info}
            />
          </motion.div>
        )}

        {['S4', 'S5', 'S6'].includes(currentState) && (
          <motion.div
            key={'quiz' + voteState?.id}
            style={{ width: '100%' }}
            initial={{ y: '100vh' }}
            animate={{ y: 0 }}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.5 }}>
            <AdvtTop advtInfo={advt_info} currentState={currentState} />
            <AnimatePresence mode="wait">
              {['S4', 'S5'].includes(currentState) && (
                <motion.div
                  key="quiz"
                  style={{ width: '100%', height: '100%' }}
                  exit={{ x: '-100vw' }}
                  transition={{ duration: 0.5 }}>
                  <Quiz
                    variants={voteState?.vars}
                    title={voteState?.title}
                    questionImgUrl={voteState?.questionImgUrl}
                    currentState={currentState}
                    questionFontSize={questionFontSize}
                    answerFontSize={answerFontSize}
                    varNumFontSize={varNumFontSize}
                    winnerFontSize={winnerFontSize}
                  />
                </motion.div>
              )}
              {currentState === 'S6' && (
                <motion.div
                  key="winner"
                  style={{ width: '100%', height: '100%' }}
                  exit={{ x: '-150vw' }}
                  transition={{ duration: 0.5 }}>
                  <Winner
                    questionImgUrl={voteState?.questionImgUrl}
                    winnerFontSize={winnerFontSize}
                  />
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        )}
      </AnimatePresence>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
